export default __webpack_public_path__ + "static/media/sbj-mathematics.3491f6ba.svg";